import { useContext } from 'react';
import NotificationsContext from 'src/context/NotificationsContext';
import useUserInfo from 'src/hooks/useUserInfo';
import { markAsReadAll, markAsRead, deleteAllByUserId } from 'src/api/notifications';

const useNotifications = () => {
  const userInfo = useUserInfo();

  const { notifications, setNotifications, dbNotifications, refreshMyDbNotifications, removeAlldbNotifications } = useContext(NotificationsContext);

  const markAllAsReadFunc = async () => {
    try {
      await markAsReadAll(userInfo.id);

      dbNotifications.forEach((notification) => {
        notification.is_read = true;
      });
      const unread = notifications.filter((notification) => !dbNotifications.some((dbNotification) => dbNotification.message_id === notification.id));
      setNotifications(unread);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteAllUserNotificationsFunc = async () => {
    try {
      await deleteAllByUserId(userInfo.id);
      removeAlldbNotifications();
      const unread = notifications.filter((notification) => !dbNotifications.some((dbNotification) => dbNotification.message_id === notification.id));
      setNotifications(unread);
    } catch (error) {
      console.error(error);
    }
  };

  const markAsReadFunc = async (id) => {
    try {
      await markAsRead(id);
    } catch (error) {
      console.error(error);
    }
  };

  const removeNotification = async (id) => {
    const notification = dbNotifications.find((notif) => notif.message_id === id);
    if (notification) {
      console.log('Mark notification as read (db)');
      await markAsReadFunc(notification.id);
      for (let i = 0; i < dbNotifications.length; i++) {
        if (dbNotifications[i].id === notification.id) {
          dbNotifications[i].is_read = true;
          break;
        }
      }
    }

    setNotifications(notifications.filter((notification) => notification.id !== id));
  };

  return { notifications, setNotifications, removeNotification, dbNotifications, refreshMyDbNotifications, markAllAsReadFunc, deleteAllUserNotificationsFunc };
};

export default useNotifications;
